<!-- 询价审核 -->
<template>
   <div class='page_content'>
      <subComponents ref="showSelectData"></subComponents>
      <div class="page_content_top">
         <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" @openFormDesign="openFormDesign"></v-button>
         <div class="page_content_top_line">
            <el-form @submit.native.prevent :inline="true" :model="getRequestData" class="demo-form-inline" v-if="pageShowData.jurHead" size="mini">
               <el-form-item :label="formOneValue.showField" v-if="formOneValue.isShow == 1" v-for="(formOneValue, formOneKey) in pageShowData.jurHead.jurconfigform" :key="formOneKey"
                             :rules="formOneValue.isRequired == 1 ? [{ required: formOneValue.isChange == 1, trigger: ['blur', 'change'] }] : []">
                  <el-input v-if="formOneValue.entityField == 'pspmBuycus'" @focus="$refs['showSelectData'].openBox('supplierList', 'supplier', '')" v-model.trim="getRequestData.smName" clearable
                            :maxlength="$store.state.inputLength">
                  </el-input>
                  <selectTableKey v-else-if="formOneValue.entityField == 'gmId'" :Columns="columns" @inputChange="inputChangeEdit" :handleRegionNodeClick="handleRegionNodeClickEdit" :label="''" :showTree="showTreeEdit"
                                  :formInline="formInlineEdit" :memberList="goodDanHaoList" @showChange="showChangeEdit" @noShowChange="noShowChangeEdit" :placeholder="'点击选择产品'" :seachholder="'输入产品名称，按enter快速检索'" />
                  <el-input v-else v-model.trim="getRequestData[formOneValue.entityField]" :maxlength="$store.state.inputLength" clearable></el-input>
               </el-form-item>
               <el-form-item>
                  <el-button type="primary" size="mini" @click="searchData">查询</el-button>
               </el-form-item>
            </el-form>
         </div>
      </div>
      <div class="page_content_center">
         <div style="width: 60vw;">
            <el-table class="mainTable" ref="minTable" size="mini" v-if="pageShowData.jurTableVo" @row-click="goodPriceClick" stripe :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum" border
                      highlight-current-row>
               <el-table-column align="center" v-if="tableValye.isShow == 1" v-for="(tableValye, tableKey) in pageShowData.jurTableVo.jurconfigtable" :key="tableKey" :prop="tableValye.entityField"
                                :label="tableValye.showField" :min-width="tableValye.fieldWeight">
                  <template slot-scope="scope">
                     <div v-if="tableValye.entityField == 'pspmState'">
                        {{ scope.row.pspmState == 0 ? '初始' : '已转为订单' }}
                     </div>
                     <div v-else-if="tableValye.entityField == 'pspmSdate'">
                        {{ $common.getLocalTime(scope.row.pspmSdate) }}
                     </div>
                     <div v-else-if="tableValye.fieldType == 'formatter'">
                        <el-tag size="mini" type="primary">{{ $common.getIsGsp(tableValye.formatterContent,
                                    scope.row[tableValye.entityField]) }}</el-tag>
                     </div>
                     <div v-else-if="tableValye.entityField == 'lackNum'">
                        <el-input v-if="scope.row.edit" v-model="scope.row.lackNum" @blur="blurUpdate(scope.row)"></el-input>
                        <span v-else>{{ scope.row.lackNum }}</span>
                     </div>
                     <div v-else>
                        {{ scope.row[tableValye.entityField] }}
                     </div>
                  </template>
               </el-table-column>
            </el-table>
         </div>
         <div style="width: calc(40vw - 20px);">
            <el-table class="mainTable" ref="mxTable" size="mini" v-if="pageShowData.jurFormVoList" :data="goodPriceList" :height="tableHeight" :key="$store.state.tableNum" border highlight-current-row>
               <el-table-column label="操作" align="center" fixed="left" min-width="60px">
                  <template slot-scope="scope">
                     <el-tag size="mini" type="primary" @click="subDetail(scope.row)">选择</el-tag>
                  </template>
               </el-table-column>
               <el-table-column label="询价记录" align="center">
                  <el-table-column align="center" v-if="tableValye.isShow == 1" v-for="(tableValye, tableKey) in pageShowData.jurFormVoList[0].jurconfigform" :key="tableKey" :prop="tableValye.entityField"
                                   :label="tableValye.showField" :min-width="tableValye.fieldWeight"></el-table-column>
               </el-table-column>
            </el-table>
         </div>
      </div>
      <!-- <div class="page_content_center" style="display: flex; justify-content: space-between;">
         
         
      </div> -->
      <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
         <SearchScheme ref="searchScheme" :id="seId" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
      </el-dialog>
      <el-dialog :title="exTitle" v-if="DialogExtract" :visible.sync="DialogExtract" :width="exWidth">
         <ExtractionScheme ref="extractionScheme" :id="exId" @TranData="getDataByChen" @getWidth="getWidth" @sendTitle="getExtractName" />
      </el-dialog>
      <customDesign ref="customDesign"></customDesign>

   </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
// import { openDB, read, getAll } from "@/byComponents/indexdb.js";
import SearchScheme from "../../byComponents/SearchScheme.vue";
import ExtractionScheme from "../../byComponents/ExtractionScheme.vue";
import selectTableKey from "@/components/selectTableKey.vue";
export default {
   //import引入的组件需要注入到对象中才能使用
   components: {
      SearchScheme,
      ExtractionScheme,
      selectTableKey
   },
   data() {
      //这里存放数据
      return {
         tableHeight: 0,
         exId: "1",
         seId: "51",
         sField: "",
         dialogTitle: "",
         seWidth: "",
         seType: "",
         seIndex: 0,
         exTitle: "",
         seTitle: "",
         seWidth: "",
         exWidth: "",
         DialogVisible: false,
         DialogExtract: false,
         chenform: {},
         tableData: [
            {
               createTime: "2016-05-02",
               bgmName: "王小虎",
               pspmId: "上海市普陀区金沙江路 1518 弄",
            },
            {
               createTime: "2016-05-04",
               bgmName: "王小虎",
               pspmId: "上海市普陀区金沙江路 1517 弄",
            },
         ],
         columns: [
            {
               prop: "gmId",
               label: "单号",
            },
            {
               prop: "createTime",
               label: "创建时间",
            },
         ],
         getRequestData: {
            businessId: "",
            bgmName: "",
            page: 1,
            rows: 30,
            start: "",
            end: "",
            gmId: "",
         },
         requestData: {},
         returnData: {
            pages: 0, // 总页数
            total: 0, // 总条数
            pageNum: 0, // 当前页数
            list: [],
         },
         buttonList: [],
         multipleSelection: [],
         pageShowData: [],
         formDataList: [],
         selectedDataIndex: 0,
         selectedDetailsDataIndex: "",
         parentSearchData: {},
         goodIds: "",
         goodPriceList: [],
         goodDanHaoList: [],
         defaultData: {
            "contact": "",
            "inquiryMethod": "",
            "phone": "",
            "smName": "",
            "price": "",
            "pspdId": 0,
            "remark": "",
            "smId": 0
         },
         showTreeEdit: false,
         formInlineEdit: "",

      };
   },
   //监听属性 类似于data概念
   computed: {},
   //方法集合
   methods: {
      openFormDesign() {
         let pathInfo = parent.getMenuInfo(this.$route.path)

         this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
      },
      handleRegionNodeClickEdit(data) {
         console.log('handleRegionNodeClickEdit', data);
         // this.formBaseEdit.productid = data.productid;
         this.formInlineEdit = data.gmId; //记录
         this.getRequestData.gmId = data.gmId;
         this.showTreeEdit = false;
         this.getDataList();
      },
      inputChangeEdit(e) {
         this.getRequestData.gmId = e;
         this.getDataPriceList()
      },
      showChange(e) {
         this.showTree = e;
      },
      noShowChange(e) {
         this.showTree = e;
      },
      showChangeEdit(e) {
         this.showTreeEdit = e;
      },
      noShowChangeEdit(e) {
         this.showTreeEdit = e;
      },
      goodPriceClick(row) {
         this.goodIds = row.pspdId;
         this.getDataPriceList()
      },
      async subData() {
         let midArr = JSON.parse(JSON.stringify(this.goodPriceList))
         let len = midArr.length
         for (let i = 0; i < len; i++) {
            const v = midArr[i];
            if (parseFloat(v.price) <= 0) {
               return this.$message({
                  message: '请填写正确价格！',
                  type: "error",
               });
            }
            v['pspdId'] = this.goodIds
         }
         let responseData = await this.$http.addGoodsInquiry(midArr);
         if (responseData.status == 200) {
            this.$message({
               message: "操作成功",
               type: "success",
            });
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      //检索Id, 索引(表格中), 标识
      openSearch(sId, index, type, sField) {
         this.DialogVisible = true;
         this.seId = sId;
         this.seIndex = index;
         this.seType = type;
         this.sField = sField;
         this.parentSearchData[type] = this.sendDataInfo[type]
      },
      // 赋值字段
      paramValue(val) {
         let arr = this.sField.split(',')
         arr.forEach(item => {
            this.$set(this.goodPriceList[this.seIndex], item, val[item])
         })
         this.goodPriceList.splice(1, 0)
         console.log('this.goodPriceList', this.goodPriceList);
      },
      changeInputModel(val) {
         if (val != "" || val != undefined) {
            this.DialogVisible = false;
            this.paramValue(val)
         }
      },

      subDetail(data) {
         this.$confirm('确定选择该记录吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
         }).then(() => {
            this.chooseData(data)
         }).catch(() => {
         });
      },
      blurUpdate(row) {
         row['edit'] = false
      },

      // 勾选明细
      handleSelectionChange(val) {
         this.multipleSelection = val;
      },
      getDataByChen(val) {
         console.log(val);
         this.DialogExtract = false;
         this.tableData = val.arrlistbychen;
         this.chenform = val;
      },
      // 提取方案
      handleClickExtraction() {
         this.DialogExtract = true;
         this.exId = "1";
      },
      handleClickCeShi() {
         this.DialogExtract = true;
         this.exId = "2728738889732096";
      },
      getSeWidth(e) {
         console.log(e);
         this.seWidth = e + "%";
      },
      getWidth(e) {
         console.log(e);
         this.exWidth = e + "%";
      },
      getSearchName(e) {
         console.log(e);
         this.seTitle = e;
      },
      getExtractName(e) {
         console.log(e);
         this.exTitle = e;
      },
      // 检索方案
      handleClickEjectDialog() {
         this.DialogVisible = true;
         this.seId = "1123";
      },
      handleClickSearch() {
         this.DialogVisible = true;
         this.seId = "2728430943932416";
      },
      //   =----------------------------------------------------------------------------------
      selectedDetailsDataAction(data) {
         var info = data.split(",").map(Number);
         this.selectedDataIndex = info[0];
      },
      // 获取数据列表
      async getPageInfo() {
         var pathId = parent.getMenuInfo(this.$route.path);
         let responseData = await this.$http.getJur({ ids: [pathId.jurId] });
         if (responseData.status == 200) {
            this.pageShowData = responseData.result;
            this.formDataList = this.pageShowData.jurFormVoList
            var obj = {}
            if (this.pageShowData.jurHead) {
               obj = this.$common.getSearchData(this.pageShowData.jurHead.jurconfigform, 'page', "rows", 30)
            } else {
               obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
            }
            for (const key in obj) {
               this.$set(this.getRequestData, key, obj[key])
            }
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      async chooseData(data) {
         let params = {
            price: data.price, //	价格
            pspdId: this.goodIds, //	缺货记录ID
            smId: data.smId, //	供应商ID
         }
         let responseData = await this.$http.goodlackmasterChoose(params);
         if (responseData.status == 200) {
            this.$message({
               type: 'success',
               message: '操作成功!'
            });
            this.getDataList();
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },


      // 动作集合
      actionSet(actionData) {
         console.log(actionData.actionType);
         switch (actionData.actionType) {
            case 0:
               this.generatePlan();
               break;
            case 1:
               // this.openActionBox(actionData.actionType)
               break;
            case 2:
               this.delDataAction();
               break;
            case 3:
               this.planToOrder();
               break;
         }
      },
      generatePlan() {
         this.$confirm("确定生成吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
         }).then(async () => {
            let responseData = await this.$http.goodlackmasterGeneratePlan({
               "ids": [this.formInlineEdit]
            });
            if (responseData.status == 200) {
               this.$message({
                  type: "success",
                  message: "操作成功!",
               });
               this.getDataList();
            } else {
               this.$message({
                  message: responseData.message,
                  type: "error",
               });
            }
         })
            .catch(() => { });
      },
      // 数据搜索
      searchData() {
         this.getRequestData.page = 1;
         this.getDataList();
      },
      // 数据翻页
      setDataPageNumber(val) {
         this.getRequestData.page = val;
         this.getDataList();
      },

      // 切换显示条数
      setDataPageSize(val) {
         this.getRequestData.page = 1;
         this.getRequestData.rows = val;
         this.getDataList();
      },

      // 获取数据列表
      async getDataList() {
         let responseData = await this.$http.queryInquiryGoodsByNum({ ids: [this.getRequestData.gmId] });
         if (responseData.status == 200) {
            this.returnData.list = responseData.result.list;
            this.selectedDataIndex = 0;
            if (this.returnData.list.length > 0) {
               this.goodIds = this.returnData.list[0].pspdId;
               this.getDataPriceList()
            }
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      // 获取价格数据列表
      async getDataPriceList() {
         this.goodPriceList = []
         let responseData = await this.$http.queryInquiryByPspdId({
            ids: [this.goodIds]
         });
         if (responseData.status == 200) {
            this.goodPriceList = responseData.result;
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      // 获取单号
      async getDanHao() {
         this.goodPriceList = []
         let responseData = await this.$http.goodlackmasterNum();
         if (responseData.status == 200) {
            this.goodDanHaoList = responseData.result;
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },

      // 提交记录
      planToOrder() {
         // console.log('ggggg', this.requestData);
         if (this.multipleSelection.length < 1) {
            this.$message({
               message: "请先选中要操作的数据",
               type: "error",
            });
            return false;
         }
         this.$confirm("若未完善询价记录将默认最后一次购进单位及价格,确定提交吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
         })
            .then(async () => {
               var ids = []
               this.multipleSelection.forEach(v => {
                  ids.push(v.pspdId)
               })
               let responseData = await this.$http.submitGoodsInquiry({
                  ids: ids
               });
               if (responseData.status == 200) {
                  this.$message({
                     type: "success",
                     message: "操作成功!",
                  });
                  this.getDataList();
               } else {
                  this.$message({
                     message: responseData.message,
                     type: "error",
                  });
               }
            })
            .catch(() => { });
      },

      // 删除数据
      delDataAction() {
         if (!dataInfo) {
            this.$message({
               message: "请先选中要操作的数据",
               type: "error",
            });
            return false;
         }
         console.log(dataInfo);
         this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
         })
            .then(async () => {
               var delData = {
                  ids: [dataInfo.pspmId],
               };
               let responseData = await this.$http.delPurchasePlan(delData);
               if (responseData.status == 200) {
                  this.$message({
                     type: "success",
                     message: "删除成功!",
                  });

                  this.getDataList();
               } else {
                  this.$message({
                     message: responseData.message,
                     type: "error",
                  });
               }
            })
            .catch(() => { });
      },

      async getButtonList() {
         this.buttonList = await this.$common.getActionButton();
      },
      //获取状态
      getIsGsp(str, val) {
         // console.log(str, val)
         try {
            if (str.indexOf("[") === -1) return val;
            str && str.replace(/\\/g, "");
            let arr = JSON.parse(str);
            let len = arr.length;
            let newStr = "";
            for (let i = 0; i < len; i++) {
               if (arr[i].key == val) {
                  newStr = arr[i].value;
                  break;
               }
            }
            console.log(newStr)
            return newStr ? newStr : val;
         } catch (ex) {
            return val;
         }
      },

      // 获取字典数据
      // async getPartDictionariesData() {
      //   let responseData = await this.$http.getPartDictionariesData({
      //     ids: [6, 7, 8],
      //   });
      //   if (responseData.status == 200) {
      //     this.dictionariesData = responseData.result;
      //   } else {
      //     this.$message({
      //       message: responseData.message,
      //       type: "error",
      //     });
      //   }
      // },
   },
   //生命周期 - 创建完成（可以访问当前this实例）
   created() {
      this.getPageInfo();
      this.getButtonList();
      this.getDanHao()
   },
   //生命周期 - 挂载完成（可以访问DOM元素）
   mounted() { },
   beforeCreate() { }, //生命周期 - 创建之前
   beforeMount() { }, //生命周期 - 挂载之前
   beforeUpdate() { }, //生命周期 - 更新之前
   updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
   beforeDestroy() { }, //生命周期 - 销毁之前
   destroyed() { }, //生命周期 - 销毁完成
   activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style  scoped>
.table_content_tag {
   margin-right: 1rem;
}

.el-tabs--border-card_new {
   height: 85vh;
   overflow-y: scroll;
}

.btns {
   display: flex;
   position: absolute;
   z-index: 999;
   padding-left: 10px;
   padding-top: 2px;
}
.page_content_center {
   width: calc(100vw - 20px);
   display: flex;
   align-items: center;
   justify-content: space-between;
}
</style>
